import { customerReducer as customer } from './reducers';

const customerState = { reducers: { customer } };

export default customerState;
